import { QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';
import { createBrowserRouter } from 'react-router';
import { RouterProvider } from 'react-router/dom';

import { useApplyTheme } from '@/entities/viewer';
import { ColorTools } from '@/features/color-palettes';
import { HelpTipProvider } from '@/features/help-center';
import { ColorLibraryProvider, type ColorLibraryProps, ToastProvider } from '@/shared/ui';

import { createQueryClient } from './query-client';
import { routes } from './routes';

const router = createBrowserRouter(routes);

/** The palette library every color picker with a free color gets (favorites + palettes). */
const renderColorTools = (props: ColorLibraryProps) => <ColorTools {...props} />;

/** Lives inside the providers so it can read the viewer; renders nothing. */
function ThemeSync() {
  useApplyTheme();
  return null;
}

export function App() {
  const [queryClient] = useState(createQueryClient);
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <ColorLibraryProvider value={renderColorTools}>
          <HelpTipProvider>
            <ThemeSync />
            <RouterProvider router={router} />
          </HelpTipProvider>
        </ColorLibraryProvider>
      </ToastProvider>
    </QueryClientProvider>
  );
}
